import { AccountService } from "../../services/account-service";
import * as URI from "urijs";
import { NotifyService } from "../../services/notify-service";

export class LoginController {
    static $inject = ["$scope", "$q", "$window", "accountService", "notifyService"];

    email: string;
    password: string;
    rememberMe: boolean = false;
    returnUrl: string = "";

    emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

    showLogin: boolean = false;
    showSSO: boolean = false;
    showPassword: boolean = false;

    ssoAuthNRequest: string = null;
    ssoEndpoint: string = null;
    ssoAppUrlID: number = null;

    lastRequest = null;

    errorMessage: string;

    inc: number = 0;

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private accountService: AccountService, private notifyService: NotifyService) {
    }

    Init(returnUrl: string) {
        this.returnUrl = returnUrl;
    }

    CheckUser() {
        if (this.emailRegex.test(this.email)) {
            this.notifyService.startProgress();

            var thisInc = this.inc++;
            this.lastRequest = thisInc;
            this.accountService.getLoginOptions(this.email)
                .then((result) => {
                    if (this.lastRequest == thisInc) {

                        var showPassword = result.showPassword;
                        this.showPassword = showPassword;
                        this.showLogin = showPassword;
                        this.showSSO = result.showSSO;
                        this.ssoEndpoint = result.ssoEndpoint;
                        this.ssoAuthNRequest = result.ssoAuthNRequest;
                        this.ssoAppUrlID = result.ssoAppUrlID;
                    }
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        else {
            this.showPassword = false;
            this.showLogin = false;
            this.showSSO = false;
        }
    }

    Submit(form: ng.IFormController) {
        if (form.$valid) {

        }
        return true;
    }

    SubmitPassword(form: ng.IFormController) {
        this.errorMessage = null;
        if (form.$valid) {
            this.notifyService.startProgress();
            this.accountService.login(this.email, this.password, this.rememberMe)
                .then((result) => {
                    var returnURL = this.GetReturnURL();

                    //result.result = "failure";

                    switch (result.result) {
                        case "success":
                            // redirect to redirectURL
                            if (!_.isEmpty(returnURL)) {
                                this.Redirect(returnURL);
                            } else {
                                this.Redirect("/");
                            }
                            break;
                        case "choose_application":
                            // redirect to /Account/ChooseApplication?returnURL=[returnURL]
                            this.Redirect("/Account/ChooseApplication", returnURL);
                            break;
                        case "require_pw_reset":
                            // redirect to /Account/RequireReset?email=[email]
                            this.Redirect("/Account/RequireReset", null, this.email);
                            break;
                        case "locked_out":
                            // redirect to /Account/Lockout.
                            this.errorMessage = "Your account has been locked out";
                            break;
                        case "two_factor":
                            // redirect to /Account/TwoFactor?returnUrl=[returnUrl]
                            this.Redirect("/Account/TwoFactor", returnURL);
                            break;
                        case "incomplete_profile":
                            // redirect to /Account/Manage?message=4
                            this.Redirect("/Account/Manage?message=4");
                            break;
                        case "failure":
                        default:
                            // show error message
                            this.errorMessage = result.message;
                            break;
                    }
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        return true;
    }

    private GetReturnURL() {
        var qs = URI.parseQuery(URI.parse(this.$window.location.href).query);

        var url = qs["ReturnUrl"];
        // cute little hack to parse URL's
        if (!_.isEmpty(url)) {
            var parser = document.createElement("a");
            parser.href = url;

            if (parser.hostname != window.location.hostname) {
                return null;
            }
        }

        var key = _.find(_.keys(qs), k => k.toLowerCase() == "returnUrl".toLowerCase());
        if (key != null) {
            return decodeURIComponent(qs[key]);
        } else {
            return null;
        }
    }

    private Redirect(url: string, returnURL: string = null, email: string = null) {
        var uri = URI(url);
        if (!_.isEmpty(returnURL)) {
            uri.addQuery({ "returnURL": returnURL });
        }
        if (!_.isEmpty(email)) {
            uri.addQuery({ "email": email });
        }

        this.$window.location.href = uri.valueOf();
    }

    SubmitSSO(form: ng.IFormController) {
        if (form.$valid) {
            var input = $("<input />")
                .attr("type", "hidden")
                .attr("name", "SAMLRequest")
                .attr("value", this.ssoAuthNRequest);
            var input2 = $("<input />")
                .attr("type", "hidden")
                .attr("name", "RelayState")
                .attr("value", this.BuildRelayState());
            var f = $("<form></form>");
            f.attr("action", this.ssoEndpoint)
                .attr("method", "post")
                .attr("enctype", "application/x-www-form-urlencoded")
                .append(input)
                .append(input2);

            $("body").append(f);
            f.submit();
        }
        return true;
    }

    BuildRelayState() {
        var output: _.Dictionary<string|number> = {};
        if (this.ssoAppUrlID > 0) {
            output.appUrlID = this.ssoAppUrlID
        }
        if (!_.isEmpty(this.returnUrl)){
            output.returnURL = this.returnUrl;
        }
        return JSON.stringify(output);
    }


}